export default {
  name: 'dashify:ArrayMap',
  title: 'Array Map',
  owner: 'User: Nachi Mistry',
  solution: '',
  tags: ['html', 'element'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    view: [
      [
        'dashify:ElementMap',
        {
          array: [1, 2, 3],
          render: "function($item){ ['p', {}, $item] }",
        },
      ],
    ],
  },
};
